import React, {useState, useEffect} from "react";
import {Form, Button, Card, Modal, notification, Row, Col, Input} from 'antd';
import jsonfile from './journal.json'
import { Link, useHistory } from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import {ExclamationCircleOutlined} from '@ant-design/icons';

const {confirm} = Modal;

const JournalDetails = (props) => {

    const [state, setState] = useState([]);
    const [entry, setEntryDetails] = useState([]);
    const [form] = Form.useForm();
    const [difference,setDifference] = useState(0);
    const [selected,setSelected] = useState([]);
    const [total,setTotal] = useState({
        totalDebit: 0,
        totalCredit: 0,
    });

    const [verifyModal, setVerifyModal] = useState(false);

    const history = useHistory();


    useEffect(() => {
        getReconcileData();
    }, []);

    const getReconcileData = () => {
        document.getElementById("loader").style.display = "block";
        const jID = props.match.params.id;
        axios.get(Config.apiserver + jsonfile.urls.view+"/"+jID)
            .then(res => {
                console.log(res)
                if (res.data.status === 1) {
                    setState(res.data.data);
                    const dt = res.data.data;
                    if(dt.length > 0) {
                        setEntryDetails({
                            date : dt[0].date,
                            company : dt[0].company,
                            entry_number : dt[0].entry_number,
                            is_adjustable : dt[0].is_adjustable,
                            status : dt[0].status
                        });

                        setTotal({
                            totalDebit: res.data.totalDebit,
                            totalCredit: res.data.totalCredit
                        })
                    }
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch(errors => {
                console.log(errors.response.data.errors);
                document.getElementById("loader").style.display = "none";
            });
    }

    const onFinish = values => {
        console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.alltransactions+"/?type=2&"+qsup;
        setState({reqURL: newURL});
    };

    const handleOnFilter = ({ target: { name, value } }) => {
        //filterValue = value;
        console.log("filteringwith :"+ value);
        setState({filtervalue : "test"});
    }

    const setSelection = (e) => {
        let slct = selected;
        const vl = parseInt(e.target.value);
        if(e.target.checked) {
            if(selected.some(item => item === vl)) {

            }
            else {
                slct.push(vl);
            }
        }
        else {
            if(selected.some(item => item === vl)) {
                var index = slct.indexOf(vl); // Let's say it's Bob.
                slct.splice(index,1);
            }
        }
        setSelected(slct);

        let receipt = 0;
        let payment = 0;
        slct.map((value,indx) => {
            state.transaction.map((itm,ind) => {
                if(itm.id === value) {
                    receipt += itm.debit;
                    payment += itm.credit;
                }
            });
        });

        console.log(receipt);
        //let gap = receipt - payment;
        const totalGap = state.ending_balance - (state.balance + receipt - payment);
        setDifference(totalGap);

    }

    const JournalVoid = (hashdata) => {
        document.getElementById("loader").style.display = "block";

        axios.post(Config.apiserver + jsonfile.urls.void, hashdata)
            .then(res => {
                console.log(res)
                if (res.data.status === 1) {
                    notification.warning({
                        message: 'Alert',
                        type: "success",
                        description: res.data.msg
                    });
                    history.push("../../entries/journlalist");
                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch(errors => {
                console.log(errors);
                // document.getElementById("loader").style.display = "none";
            });
    }

    // const showConfirmVoid = () => {
    //     confirm({
    //         title: 'Journal Void Confirmation',
    //         icon: <ExclamationCircleOutlined/>,
    //         okText: "Yes",
    //         cancelText: "No",
    //         content: <>
    //             <div className="row">
    //                 <div className="col-md-12">
    //                     <h4>Are you sure you want to void this journal?</h4>
    //                 </div>
    //             </div>
    //         </>,
    //         onOk() {
    //             console.log('OK');
    //             JournalVoid();
    //         },
    //         onCancel() {
    //             console.log('Cancel');
    //         },
    //     })
    // }

    const handleVoidVoucher = () => {
        setVerifyModal(true);
    }

    const handleVerifyCancel = () => {
        setVerifyModal(false);
    }

    const voidJournalVerify = (values) => {
        const jID = props.match.params.id;
        let data = {
            "userid": values['userid'],
            "password": values['password'],
            "thread": jID
        }
        axios
            .post(Config.apiserver + "accounts/journalvoidverify", data)
            .then((res) => {
                if (res.data.status === 1) {
                    const newHashData = {
                        'token': res?.data?.token,
                        'thread': jID
                    };
                    setVerifyModal(false);
                    showConfirm(newHashData);
                    CisUI().showAlert("Success", "success", res.data.msg);
                } else {
                    CisUI().showAlert("Error", "error", res.data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }


    const showConfirm = (hashData) => {
        console.log("showConfirm", hashData);
        Modal.confirm({
            title: 'Confirmation',
            content: 'Are you sure you want to void these journal?',
            okText: 'Ok',
            cancelText: 'Cancel',
            onOk() {
                JournalVoid(hashData);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const extraItems = (
        <>
            <Button type="info" onClick={() => history.goBack()} htmlType="back">Back</Button>
            <Button type="info" onClick={() => window.print()} htmlType="back">Print</Button>
            {
                entry.status === 3 ? <>
                    <Button type="info" htmlType="button">Voided</Button>
                </> : <>
                    {
                        entry.is_adjustable === 1 ? <>
                            <Button id="submitbutton" type="primary" htmlType="button">
                                <Link to={"../journaledit/"+entry.entry_number}>Edit</Link>
                            </Button>
                            <Button type="info" style={{ background: "#f30000", border: "1px solid #d00303", color: "#fff"}} onClick={handleVoidVoucher} htmlType="button">Void</Button>
                        </> : <></>
                    }
                </>
            }
        </>
    );
    return (
        <>
            <Card title={"Entry details - "+entry.entry_number} extra={extraItems}>
                {CisUI().showLoading}
                <div className="row">
                    <div className="col-md-12">
                        <div>
                            <label><strong>Company</strong> : </label> {entry.company}<br />
                            <label><strong>Date</strong> : </label> {CisUI().DateFormat(entry.date)}<br />
                            <label><strong>Entry Number</strong> : </label> {entry.entry_number}<br />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="table-responsive" style={{marginTop : '20px'}}>
                            <table className="table table-bordered">
                                <thead>
                                <tr>
                                    <th>Account</th>
                                    <th>Description</th>
                                    <th>Beneficiary</th>
                                    <th style={{textAlign : 'right !important'}}>Debit ({CisUI().getCurrencySymbol()})</th>
                                    <th style={{textAlign : 'right !important'}}>Credit ({CisUI().getCurrencySymbol()})</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    state.map((items,index) => {
                                        return <tr>
                                            <td>{items.account}</td>
                                            <td style={{ textWrap: "balance" }}>{items.description}</td>
                                            <td>{items.beneficiary}</td>
                                            <td style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(items.debit)}</td>
                                            <td style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(items.credit)}</td>
                                        </tr>
                                    })
                                }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={3}>Total = </th>
                                        <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(total.totalDebit)}</th>
                                        <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(total.totalCredit)}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </Card>

            <Modal title="Verify Your Identity" open={verifyModal}
                   okButtonProps={{form: 'verify', key: 'submit', htmlType: 'submit'}}
                   okText={"Submit"}
                // onOk={handleOk}
                   onCancel={handleVerifyCancel}
                // footer={null}
            >
                <Form
                    id="verify"
                    form={form}
                    {...CisUI().formItemLayout}
                    name="input"
                    // className="ant-advanced-search-form"
                    onFinish={voidJournalVerify}
                >
                    <Row gutter={24}>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    label="Username"
                                    name="userid"
                                    // onChange={handleChange}
                                    rules={[
                                        {
                                            required: true,
                                            message: "Enter username"
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter username"/>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col lg={24} md={24} sm={24} xs={24}>
                            <div className="gx-form-row0">
                                <Form.Item
                                    name="password"
                                    label="Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password/>
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>

                    {/*<Row>*/}
                    {/*    <div className="col-md-12" style={{textAlign: 'center', marginTop: '30px'}}>*/}
                    {/*        <Button type="primary" htmlType="submit">*/}
                    {/*            Submit*/}
                    {/*        </Button>*/}
                    {/*        <Button type="info" onClick={handleCancel}>Cancel</Button>*/}
                    {/*    </div>*/}
                    {/*</Row>*/}
                </Form>
            </Modal>
        </>
    );
};

export default JournalDetails;